import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import IconTableHelp from "../assets/icon-table-help.svg";
import IconTableSorter from "../assets/icon-table-sorter.svg";

const HeadCell = props => {
  const { cellSize, iconType, alignText, children, className, onHelpIconClick } = props;

  return (
    <th className={className}>
      <div
        className={cn(
          "responsive-table__cell",
          `responsive-table__cell_${alignText}`,
          `responsive-table__cell_${cellSize}`
        )}
      >
        {children}
        {iconType === "sorter" && (
          <img alt="table icon sorter" src={IconTableSorter} width="12px" height="40px" />
        )}
        {iconType === "help" && (
          <img alt="table icon help" src={IconTableHelp} onClick={onHelpIconClick} width="14px" height="14px" />
        )}
      </div>
    </th>
  );
};

HeadCell.defaultProps = {
  alignText: "center",
  iconType: null,
  isGrow: true,
  isHighlighted: false,
  highlightColor: "",
  cellSize: "medium",
};

HeadCell.propsType = {
  iconType: PropTypes.oneOf(["help", "sort"]),
  alignText: PropTypes.oneOf(["left", "right", "center"]),
  cellSize: PropTypes.oneOf(["small", "medium"]),
  children: PropTypes.node,
  className: PropTypes.string,
  onHelpIconClick: PropTypes.func
};

export default HeadCell;



// WEBPACK FOOTER //
// ./src/containers/responsive-table/head-cell.js